<template>
  <div class="profil-list">

    <v-container grid-list-xl fluid >
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >

        <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
          <v-toolbar-title  class="hidden-md-and-down">
              <h2><v-icon large class="mr-2">mdi-account-group</v-icon>{{$t('administration.profil.profils')}}</h2>
          </v-toolbar-title>
          <v-spacer />
          <div>
            <v-btn
              class="ml-2"
              color="primary"
              v-if="userHasAccess('profil_edit')"
              :to="{ name: 'ProfilUserCreate' }"
            >
              {{ $t('global.add')}}
            </v-btn>
          </div>
        </v-toolbar>


          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.dateCreation" slot-scope="{ item }">
                  {{ formatDateTime(item['dateCreation'], 'long') }}
                </template>
                <template slot="item.dateUpdate" slot-scope="{ item }">
                  {{ formatDateTime(item['dateUpdate'], 'long') }}
                </template>

          </v-data-table>

      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProfilUserList',
  servicePrefix: 'ProfilUser',
  mixins: [ListMixin,AccessMixin],
  components: {

  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('global.dateCreation'), value: 'dateCreation' },
        { text: this.$t('global.dateUpdate'), value: 'dateUpdate' },
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('profil', {
      items: 'list'
    }),
    ...mapFields('profil', {

      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('profil', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
